module.exports = __webpack_public_path__ + "img/pmg4.55559087.png";